"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomClaimWorkspaceRole = void 0;
var getCustomClaimWorkspaceRole = function (_a) {
    var _b;
    var state = _a.state, workspaceId = _a.workspaceId;
    var useWorkspaceId = workspaceId || state.currentWorkspaceId;
    var roles = (_b = state.currentCustomClaim) === null || _b === void 0 ? void 0 : _b.roles;
    var role = roles && useWorkspaceId && roles[useWorkspaceId];
    return role || undefined;
};
exports.getCustomClaimWorkspaceRole = getCustomClaimWorkspaceRole;
